import { FC } from 'react';

// Components
import Match from './Match/Match';

// Types
import { INormalizedMatchV2, ISubscriberInfo } from '../../../../../packages/types';

interface Props {
  matches?: INormalizedMatchV2[];
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

const MatchList: FC<Props> = ({ matches, handleClick }) => {
  return (
    <div className='match-list-container'>
      {matches?.map((match) => (
        <Match key={match.id} match={match} handleClick={handleClick} />
      ))}
    </div>
  );
};

export default MatchList;
